import React, { useState } from 'react';
import Footer from '../../components/Footer';
import PropertyCard from '../../components/properties/PropertyCard';
import '../../styles/styles.css';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useProperty } from '../../context/PropertyContext';
import PriceConversionModal from '../../components/modals/PriceConversionModal';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { PulseLoader } from "react-spinners";

const FavoritesPage: React.FC = () => {
  const { getFavoriteProperties, loading, error } = useProperty();
  const favoritesProperties = getFavoriteProperties(); 
  const [isModalOpen, setModalOpen] = useState(false); 
  const [selectedPrice, setSelectedPrice] = useState<number>(0);

  

  const handleOpenModal = (price: number) => {
    setSelectedPrice(price);
    setModalOpen(true);
  };

  if (loading)
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#fafafa",
      }}
    >
      <PulseLoader color="#36d7b7" size={15} margin={2} />
      <Typography
        variant="h6"
        color="textSecondary"
        sx={{ mt: 3, textAlign: "center" }}
      >
        Cargando favoritos, por favor espera...
      </Typography>
    </Box>
  );

        
  if (error)
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        textAlign: "center",
        gap: 2,
        backgroundColor: "white",
      }}
    >
      <NotInterestedIcon sx={{ fontSize: 75, color: "text.secondary" }} />
      <Typography variant="h6" color="error">
        Ocurrió un error
      </Typography>
      <Typography variant="body1" color="textSecondary">
        No pudimos cargar los favoritos. Por favor, inténtalo nuevamente más tarde.
      </Typography>
    </Box>
  );


  return (
    <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <main style={{ flex: 1 }}>
        <Box 
          className="property-list" 
          sx={{ 
            minHeight: '80vh', 
            height: 'auto', 
            p: 3, 
            alignContent: favoritesProperties.length > 0 ? 'flex-start' : 'center'
          }}
        >
          {favoritesProperties.length > 0 ? (
            <Grid container spacing={2}>
              {favoritesProperties.map((property) => (
                  <Grid size={{xs:12, md:3}} key={property.id_Property}>
                  <PropertyCard property={property} onConvertPrice={handleOpenModal} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                textAlign: 'center',
                color: 'text.secondary',
                gap: 2,
              }}
            >
              <NotInterestedIcon sx={{ fontSize: 75, color: 'text.secondary' }} />
              <Typography variant="h6">
                No tienes propiedades favoritas aún.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                Explora propiedades y selecciona tus favoritas para encontrarlas aquí fácilmente.
              </Typography>
            </Box>
          
          )}
        </Box>
      </main>
      <Footer />
      
      {/* Modal de conversión de precios */}
      <PriceConversionModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        initialPrice={selectedPrice}
      />
    </Box>
  );
};

export default FavoritesPage;
